import React from 'react'
import styled, { keyframes, css } from 'styled-components'

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

interface IconProps {
  name: string
  size?: number
  color?: string
  className?: string
  fill?: string
  stroke?: string
  inheritStyles?: boolean
  spin?: boolean
}

interface StyledIconProps {
  $size: number
  $color?: string
  $fill?: string
  $stroke?: string
  $inheritStyles?: boolean
  $spin?: boolean
}

const IconWrapper = styled.svg<StyledIconProps>`
  width: ${(props) => props.$size}px;
  height: ${(props) => props.$size}px;

  ${(props) =>
    props.$spin &&
    css`
      animation: ${spin} 1s linear infinite;
      transform-origin: ${props.$size / 2}px ${props.$size / 2}px;
    `}
  ${(props) => props.$color && `color: ${props.$color};`}
  ${(props) => props.$fill && `fill: ${props.$fill};`}
  ${(props) => props.$stroke && `stroke: ${props.$stroke};`}
  ${(props) =>
    props.$inheritStyles &&
    css`
      fill: currentColor;
      stroke: currentColor;
    `}
`

export const Icon: React.FC<IconProps> = ({
  name,
  size = 24,
  color,
  className,
  fill,
  stroke,
  inheritStyles = false,
  spin = false,
}) => {
  return (
    <IconWrapper
      $size={size}
      $color={color}
      $fill={fill}
      $stroke={stroke}
      $inheritStyles={inheritStyles}
      className={className}
      $spin={spin}
    >
      <use xlinkHref={`/sprites/sprite-general.svg#${name}`} />
    </IconWrapper>
  )
}
